import React            from 'react'; 
import Newspaper        from '../components/Newspaper.jsx';
import Paper            from '../components/Paper.jsx';
import portrait         from './portrait.module.css'
import landscape        from './prompt_security.module.css';
import {Context}        from '../services/context.js'

import pic_use_case_1   from '../pictures/Luxery shoes.webp'; 
import { Helmet }       from 'react-helmet';
import cx               from 'classnames';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});

const text_1 = [
  {
    header: (
      <p className={cx_header}>
        Prompt Proxy for AI
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        Users specify their requirements for an AI system through prompts. At its simplest, this means interacting with an LLM like ChatGPT via a text‑based dialogue. 
        However, attackers can tamper with prompt text before it reaches the AI server, leaving users unaware of what’s actually being sent—an important security risk. 
        The stakes are even higher when autonomous agents act on your behalf: did the agent execute your instructions, or follow hidden commands? 
        In these scenarios, Back‑Step Blockchain can serve as both a secure proxy and an immutable logbook. 
        For details, see the white paper “Prompt Security Proxy Based on Back‑Step Blockchain” on the <b>Publications</b> page.
      </p>
    )
  },
  {
    shadow: (
      <img
        src={pic_use_case_1}
        width="230"
        alt="Prompt‑proxy use case diagram"
      />
    )
  },
  {
    text: (
      <p className={cx_text}>
        Trace every request—know who issued it and when.
      </p>
    )
  }
];

 //<img src={ pic_use_case_1} width='230' alt="Luxery_goods" />


export class PromptSecurity extends React.Component  
{

    //------------------------------------------------------------------
    //  Constructor
    //------------------------------------------------------------------
    constructor(props) 
    {
        super(props);
        this.state = {content_disabled: false}
    }

    //------------------------------------------------
    //  Component Mount
    //------------------------------------------------
    componentDidMount()
    {
        //this.forceUpdate();
        window.scrollTo({top:0, left: 0, behavious: 'smooth'});

    }


    //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    changeVisible(mode)
    {
      this.setState({content_disabled:mode})
    }

    //--------------------------------------------------------------------------
    // Prepare for rendering  -- Portrait --
    //--------------------------------------------------------------------------
    render()
    { 
      if (Context.portrait)
      {

        this.component = 
          <div className={portrait.backdrop}>
  
          <Helmet>
            <title>AI Security with Back-Step Blockchain</title>
            <meta name="description" content="Explains Back-Step Blockchain for AI." />
            <meta charset="utf-8" />
          </Helmet>
        
          <div className={cx_header}>
              Back-Step for AI
          </div>              

          <div> 
            < Paper textLines = {text_1}/> 
            
          </div>
        </div>
      }
      else
      {
      //--------------------------------------------------------------------------
      // Prepare for rendering  -- Landscape --
      //--------------------------------------------------------------------------
        this.component = 

        <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

          <Helmet>
          <title>Prompt security for AI</title>
          <meta name="description" content="Reference to a white paper" />
          <meta charset="utf-8" />
          </Helmet>

          {! this.state.content_disabled &&
          <>
           <div className={landscape.title_location}>
            <div className={landscape.title_text}>
              <p>Trust your AI system </p>
            </div>
          </div>
          
          <div className={landscape.container_2_5_2}>
                        
            <div className ={landscape.grid_item}> 
            < Paper textLines = {text_1}/> 
            </div>
          
          </div>
  
          </>
          }
        </div>
     
        return this.component;
      }
    }
}